import '../base-styles/typescale.scss';
import '../base-styles/colors.scss';
import '../base-styles/spacing.scss';
import '../base-styles/global.scss';
import '../components/components.scss';
import FooterShrink from '../components/Footer/Footer.js';
import "../components/Footer/Footer.scss"

import Menu from '../pages/Menu/Menu.jsx';
import DS from '../pages/DS/DS.jsx';
import ScrollToTop from '../ScrollToTop.jsx';
import { SpeedInsights } from "@vercel/speed-insights/react"


import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './home/Home.jsx';
import Du from './du/Du.jsx';

import ERP from './ERP/ERP.jsx';
import React, { useEffect } from 'react';

function App() {

  useEffect(() => {

    window.addEventListener('scroll', handleScroll);

  }, []);

  function handleScroll() {
    const wrapper = document.querySelector(".wrapper");

    if (window.scrollY + window.innerHeight > wrapper.offsetHeight) {
      wrapper.classList.add("tight");


    }
    else {

      wrapper.classList.remove("tight");

    }
  }


  return (

    <Router>
      <ScrollToTop />
      <SpeedInsights/>

      <div className='master-wrapper'>
        <div className='wrapper'>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Du" element={<Du />} />
            <Route path="/ERP" element={<ERP />} />
            <Route path="/Menu" element={<Menu />} />
            <Route path="/DS" element={<DS />} />


          </Routes>

        </div>
        <FooterShrink />
      </div>
    </Router>


  );
}

export default App;
